/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { deepMerge, logger } from "@nosto/search-js/utils"
import { Config, defaultConfig, FullConfig } from "./config"
import defaultMappers from "./urlEncoding/defaultMappers"
import { handleFallback, shouldFallback } from "./actions"
import { Store } from "./state"
import { SearchOptions } from "./api"
import { isErrorSession } from "./helpers/errorHandling"

export function makeConfig(config: Partial<Config>): FullConfig {
    const fullConfig = deepMerge(defaultConfig, config) as FullConfig

    if (fullConfig.compressUrlParameters && !fullConfig.customUrlMappings) {
        fullConfig.customUrlMappings = [defaultMappers]
    }

    fullConfig.onBeforeSearch = (context, options) => {
        if (config.fallback && isErrorSession()) {
            throw new Error("Search API is in error state")
        }
        const store = context.store as Store
        const searchOptions = options as SearchOptions
        store.updateState({
            customParams: searchOptions.customParams ?? {}
        })
    }

    fullConfig.onSearchError = (error, query, _, pageType) => {
        if (config.fallback && pageType !== "autocomplete") {
            if (shouldFallback(error)) {
                handleFallback(fullConfig, query)
            } else {
                logger.info("Skipping fallback logic for ", error)
            }
        }
    }

    fullConfig.search = {
        hitDecorators: fullConfig.hitDecorators,
        maxRetries: fullConfig.retries,
        retryInterval: fullConfig.retryInterval
    }

    return fullConfig
}
